<div
  class="fixed inset-0 z-[200] flex items-center justify-center p-6 bg-slate-950/40 backdrop-blur-sm animate-in fade-in duration-300"
  role="dialog"
  aria-modal="true"
  aria-labelledby="tour-title"
>
  <div
    class="bg-white rounded-[2.5rem] shadow-2xl max-w-md w-full p-10 relative overflow-hidden border border-indigo-100"
  >
    <div class="absolute top-0 right-0 w-32 h-32 bg-indigo-50 rounded-bl-full -z-10"></div>

    <button
      (click)="handleComplete()"
      class="absolute top-6 right-6 p-2 text-slate-300 hover:text-slate-500 transition"
      aria-label="Fechar tour"
    >
      <lucide-icon [img]="icons.x" class="w-5 h-5"></lucide-icon>
    </button>

    <div class="flex flex-col items-center text-center">
      <div
        class="w-16 h-16 bg-indigo-600 rounded-2xl flex items-center justify-center shadow-lg shadow-indigo-600/30 mb-8"
      >
        <lucide-icon [img]="step.icon" class="w-8 h-8 text-white"></lucide-icon>
      </div>

      <div class="space-y-4">
        <span
          class="text-[10px] font-black text-indigo-600 uppercase tracking-widest bg-indigo-50 px-3 py-1 rounded-full"
        >
          Passo {{ currentStep() + 1 }} de {{ steps.length }} • {{ step.target }}
        </span>
        <h3
          id="tour-title"
          class="text-2xl font-black text-slate-900 tracking-tighter leading-tight mt-5"
        >
          {{ step.title }}
        </h3>
        <p class="text-sm text-slate-500 font-medium leading-relaxed">
          {{ step.description }}
        </p>
      </div>

      <div class="mt-10 w-full space-y-4">
        <button
          (click)="handleNext()"
          class="w-full bg-indigo-600 text-white py-5 rounded-[1.5rem] text-[11px] font-black uppercase tracking-[0.2em] hover:bg-indigo-700 shadow-xl shadow-indigo-600/30 transition-all flex justify-center items-center gap-3 mt-4 group disabled:opacity-50 disabled:bg-slate-300 disabled:shadow-none disabled:cursor-not-allowed cursor-pointer"
        >
          {{ isLastStep() ? 'Começar a Usar' : 'Próximo Passo' }}
          <lucide-icon [img]="icons.chevronRight" class="w-4 h-4"></lucide-icon>
        </button>

        <div class="flex justify-center gap-1.5 pt-2" role="tablist" aria-label="Passos do tour">
          @for (s of steps; track $index; let i = $index) {
            <div
              role="tab"
              [attr.aria-selected]="i === currentStep()"
              [attr.aria-label]="'Passo ' + (i + 1)"
              [class]="
                'h-1.5 rounded-full transition-all duration-300 ' +
                (i === currentStep() ? 'w-8 bg-indigo-600' : 'w-1.5 bg-slate-200')
              "
            ></div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
